"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

const CrownBadge = ({
  className
}) => /*#__PURE__*/_react.default.createElement("span", {
  className: (0, _classnames.default)('crown-badge', className)
});

CrownBadge.propTypes = {
  className: _propTypes.default.string
};
CrownBadge.defaultProps = {
  className: ''
};
var _default = CrownBadge;
exports.default = _default;